import htmlAttributes from '../../data/html-attributes.json';
export var isHtmlProp = function isHtmlProp(propName, tagName) {
  return htmlAttributes['*'].includes(propName) || (htmlAttributes[tagName] || []).includes(propName);
};